export function formatResultsCountLabel(totalRows) {
  const count = Number.isFinite(totalRows) ? Math.max(0, totalRows) : 0;
  if (count === 1001) {
    return "1,000+ companies";
  }
  const formatted = new Intl.NumberFormat("en-US").format(count);
  return `${formatted} ${count === 1 ? "company" : "companies"}`;
}
